import React from "react";
import PropTypes from "prop-types";
import Link from "arena/components/Link";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import ReactGA from "react-ga4";
import { styled } from "@mui/material/styles";
import classNames from "classnames";
import useGuidUrl from "arena/hooks/useGuidUrl";

const PREFIX = "ArenaCoverButton";

const classes = {
  small: `${PREFIX}-small`,
  medium: `${PREFIX}-medium`,
  large: `${PREFIX}-large`,
};

const StyledButton = styled(Button)(({ theme }) => ({
  [`&.${classes.small}`]: {
    fontWeight: 600,
  },

  [`&.${classes.medium}`]: {
    fontWeight: 600,
    fontSize: "1em",
    [theme.breakpoints.up("sm")]: {
      fontSize: "1.1rem",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "1.2rem",
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: "1.3rem",
    },
  },

  [`&.${classes.large}`]: {
    fontWeight: 600,
    fontSize: "1em",
    [theme.breakpoints.up("sm")]: {
      fontSize: "1.2rem",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "1.3rem",
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: "1.4rem",
    },
  },
}));

const CoverButton = function ({ button }) {
  const resultLink = useGuidUrl(button.url);
  const component = resultLink?.startsWith("/") ? Link : "a";

  const onClickButton = (event, button) => {
    ReactGA.event({
      category: "ArenaCover",
      action: "Click to button",
      label: button.text,
    });
  };

  return (
    <StyledButton
      component={component}
      to={resultLink}
      href={resultLink}
      variant={button.variant}
      color={button.color}
      size={button.size}
      onClick={(event) => onClickButton(event, button)}
      className={classNames({
        [classes.small]: button.size === "small",
        [classes.medium]: button.size === "medium",
        [classes.large]: button.size === "large",
      })}
    >
      {button.text}
    </StyledButton>
  );
};

CoverButton.propTypes = {
  button: PropTypes.object.isRequired,
};

export default function Buttons({ buttons }) {
  return buttons
    .filter(
      (button) =>
        button.text &&
        (button.disabled === undefined || button.disabled === false)
    )
    .map((button, i) => {
      return (
        <Grid item key={i}>
          <CoverButton button={button} />
        </Grid>
      );
    });
}

Buttons.propTypes = {
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      url: PropTypes.string,
      variant: PropTypes.string,
      color: PropTypes.string,
      size: PropTypes.string,
      disabled: PropTypes.bool,
    })
  ),
};
